export interface ISystem {
	red_lighten: string;
	red: string;
	red_darken: string;
	yellow_lighten: string;
	yellow: string;
	yellow_darken: string;
	green_lighten: string;
	green: string;
	green_darken: string;
	blue_lighten: string;
	blue: string;
	blue_darken: string;
}

const system: ISystem = {
	red_lighten: '#FEE6EA',
	red: '#FB3958',
	red_darken: '#8F2032',
	yellow_lighten: '#FFF8E5',
	yellow: '#FFC834',
	yellow_darken: '#91721D',
	green_lighten: '#EEF9F2',
	green: '#6DC993',
	green_darken: '#3E7254',
	blue_lighten: '#E2EDFF',
	blue: '#458EFF',
	blue_darken: '#275191',
};

export default system;
